import { useState } from "react";
import { motion } from "framer-motion";
import Navbar from "../../component/Navbar";
import DropdownMenu from "../../component/DropdownMenu";
import Footer from "../../component/Footer";
import Loading from "../../component/Loading";
import { structure } from "../../inc/DataImg_inc";
import LogoContent from "../../component/LogoContent";
import PageTransition from "../../component/PageTransition";

export default function Page() {
  const [showContent, setShowContent] = useState(false);

  return (
    <>
      <PageTransition showContent={showContent} setShowContent={setShowContent}>
        โครงสร้างศูนย์การเรียนรู้และส่งเสริมสุขภาพทางสัตวแพทย์ภาคเหนือ
      </PageTransition>

      {showContent && (
        <motion.div
          className="relative"
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          transition={{ duration: 1.5 }}
        >
          <Navbar />
          <div className="flex flex-col gap-y-10">
            <DropdownMenu />
            <LogoContent />
            <Loading data={structure}>
              <div className="container mx-auto w-full flex flex-col justify-center items-center px-5 py-5 md:px-0 md:py-0 gap-3">
                <div className="flex">
                  <span className="text-3xl font-bold text-[#0F4D81]">
                    โครงสร้าง
                  </span>
                  <span className="text-3xl font-bold text-[#9E76B3]">
                    ศูนย์การเรียนรู้และส่งเสริมสุขภาพทางสัตวแพทย์ภาคเหนือ
                  </span>
                </div>
                <div>
                  <img src={structure} className="object-cover" alt="" />
                </div>
              </div>
            </Loading>
            <Footer />
          </div>
        </motion.div>
      )}
    </>
  );
}
